import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectDatabaseEmulator, getDatabase } from "firebase/database";
import { connectFirestoreEmulator, initializeFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

export const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_APP_APIKEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_APP_AUTHDOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_APP_DATABASEURL,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_APP_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_APP_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_APP_ID,
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_APP_MEASUREMENT_ID
};

const firebase = initializeApp(firebaseConfig);

const store = initializeFirestore(firebase, {ignoreUndefinedProperties: true})
const db = getDatabase(firebase);
const auth = getAuth(firebase);
const storage = getStorage(firebase);

// web8だとauth.Rがweb9だとauth.config.emulatorがuseEmulatorで変わる部分。型は公開されてないので、tsを無視する。
// @ts-ignore
if (process.env.NEXT_PUBLIC_MODE === 'emulator' && !auth.config.emulator) {
// if (process.env.NEXT_PUBLIC_MODE === 'emulator') {
    connectDatabaseEmulator(db, "localhost", 9000);
    connectFirestoreEmulator(store, "localhost", 8080);
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectStorageEmulator(storage, 'localhost', 9199);
}

export { store, db, auth, storage };
export default firebase;
